import Component from 'vue-class-component';

// Router hooks on class components; must run before any component class is defined.
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
